import { useTranslation } from "react-i18next";
import { useAxios } from "../useAxios"
import { useQuery } from "@tanstack/react-query";
import { User } from "@types";

export const useGetUsers = () => {

    const axios = useAxios();
    const {t} = useTranslation();

    const fetchUsers = async () => {
        try {
            const { data } = await axios.get<{items: User[]}>("/api/users");
            return data;
        } catch (error) {
            throw new Error(t("messages.error.getUsers"));
        }
    }

    return useQuery({queryKey: ["users"], queryFn: fetchUsers, staleTime: Infinity, gcTime: Infinity})
}